import { Injectable } from '@angular/core';
import { VaultApiService } from '@app/core/services/api/vault-api.service';
import {
  ApiToken,
  ApiTokenListRequest,
  CreateApiTokenRequest,
  CreateApiTokenResponse,
  DecryptApiTokenResponse,
} from '@interfaces/user/api-token.interface';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserApiTokenService {
  constructor(private apiService: VaultApiService) {}

  getApiTokens(request: ApiTokenListRequest = {}): Observable<ApiToken[] | null> {
    let path = 'users/api-tokens';

    if (request.userId) {
      path = `${path}?userId=${request.userId}`;
    }

    if (request.page !== undefined) {
      path = `${path}${request.userId ? '&' : '?'}page=${request.page}`;
    }

    if (request.pageSize !== undefined) {
      path = `${path}${request.userId || request.page !== undefined ? '&' : '?'}pageSize=${request.pageSize}`;
    }

    return this.apiService.get<ApiToken[]>(path);
  }

  /**
   * Cria um token de API. Com `userId`, o token nasce para esse usuário (`POST users/api-tokens/{userId}`,
   * que confere se quem chama pode gerenciá-lo); sem ele, para o usuário logado. A modal de Usuários
   * sempre passa o `userId` da linha: sem isso o token ia para o admin que estava logado (card 3697).
   */
  createApiToken(
    request: CreateApiTokenRequest,
    userId?: string | null
  ): Observable<CreateApiTokenResponse | null> {
    const path = userId ? `users/api-tokens/${userId}` : 'users/api-tokens';
    return this.apiService.post<CreateApiTokenResponse>(path, request);
  }

  revokeApiToken(tokenId: string): Observable<null> {
    return this.apiService.delete<null>(`users/api-tokens/${tokenId}`);
  }

  decryptApiToken(tokenId: string): Observable<DecryptApiTokenResponse | null> {
    return this.apiService.get<DecryptApiTokenResponse>(`users/api-tokens/${tokenId}/decrypt`);
  }
}
